import React from "react";

export default function Payslips() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Payslips</h1>
      <p>View and download your monthly salary slips.</p>

      <ul className="mt-4 space-y-2">
        <li className="p-2 border rounded hover:bg-gray-100 cursor-pointer">December 2025</li>
        <li className="p-2 border rounded hover:bg-gray-100 cursor-pointer">November 2025</li>
        <li className="p-2 border rounded hover:bg-gray-100 cursor-pointer">October 2025</li>
      </ul>
    </div>
  );
}
